import React, { ComponentType } from 'react'
import { css } from 'src/ui/style/css'
import { useTran } from 'src/i18n/useTran'
import { msg } from 'src/i18n/texts/keys'

export const ErrorMain: ComponentType = () => {
    // TODO style
    const t = useTran()

    return (
        <div
            css={css`
                min-height: 30em;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
            `}
        >
            <span
                css={css`
                    font-size: 2em;
                `}
            >
                {t(msg.error.weApologize) + ':('}
            </span>
        </div>
    )
}
